import { remove } from 'lodash-es';
import { RESOLUTION } from '~/constants';
import { COOKIE_KEY } from '~/constants/config';
import { gotoEmptyEditor } from '~/features/createWork';
import {
  createWorkAndJumpToCharacter,
  createWorkWithPreset,
} from '~/features/createWork/index.tsx';
import { useTemplate } from '~/features/template/components/info';

export enum IAfterLoginActionType {
  /**创建作品 */
  'CREATE_WORK',
  /**使用模板 */
  'USE_TEMPLATE',
  /**3D造人 */
  'CREATE_CHARACTER',
  /** 指定素材创建作品 */
  'CREATE_WORK_WITH_PRESET',
}

interface AfterLoginAction {
  type: IAfterLoginActionType;
  payload: any;
}

class LoginTaskManager {
  cached: AfterLoginAction[] = [];

  get tasks() {
    return this.cached;
  }

  set tasks(tasks: AfterLoginAction[]) {
    this.cached = tasks;
    sessionSetItem('LOGIN_TASK', tasks);
  }

  constructor() {
    if (import.meta.client) {
      this.tasks = sessionGetItem('LOGIN_TASK') || [];
    }
  }

  add(task: AfterLoginAction) {
    const token = getCookie(COOKIE_KEY.USER_TOKEN);
    if (!token?.user_id) {
      remove(this.tasks, v => v.type === task.type);
      this.tasks.push(task);
      sessionSetItem('LOGIN_TASK', this.tasks);
    }
  }

  async flush() {
    let proc = Promise.resolve();
    while (this.tasks.length > 0) {
      const task = this.tasks.shift();
      proc = proc.then(() => {
        try {
          if (task?.type === IAfterLoginActionType.CREATE_WORK) {
            gotoEmptyEditor();
            return;
          }
          if (task?.type === IAfterLoginActionType.USE_TEMPLATE) {
            return useTemplate(...task.payload);
          }
          if (task?.type === IAfterLoginActionType.CREATE_CHARACTER) {
            createWorkAndJumpToCharacter(RESOLUTION.HORIZONTAL);
            return;
          }
          if (task?.type === IAfterLoginActionType.CREATE_WORK_WITH_PRESET) {
            createWorkWithPreset(task.payload);
            return;
          }
        } catch (err) {
          // silently ignore
        }
      });
    }
    await proc;
    this.clear();
  }

  remove(task: AfterLoginAction) {
    remove(this.tasks, v => v.type === task.type);
  }

  clear() {
    this.tasks = [];
  }
}

export const loginTask = new LoginTaskManager();
